jQuery(document).ready(function ($) {
    // Elements class names
    const ELEMENTS = {
        MAIN_NAVIGATION: 'main-navigation',
        MAIN_NAVIGATION_LIST_ITEM: 'main-navigation__list__item',
        MAIN_NAVIGATION_LIST_ITEM_ACTIVE: 'main-navigation__list__item--active',
        MOBILE_MAIN_NAVIGATION_LIST: 'mobile-main-navigation__list',
        MOBILE_MENU_BUTTON: 'mobile-menu-button'
    }
    const mainNavigation = $(`.${ELEMENTS.MAIN_NAVIGATION}`);

    // Early exit if no main navigation element found
    if (mainNavigation.length === 0) {
        return;
    }

    /**
     * Set an item in the navigation as active, if the current URL is the same as the navigation link
     */
    const setNavigationItemActive = () => {
        const currentUrl = window.location.href,
            navigationItems = $(`.${ELEMENTS.MAIN_NAVIGATION_LIST_ITEM}`);

        // Early exit if no navigation items found
        if (navigationItems.length === 0) {
            return;
        }

        navigationItems.each((index, element) => {
            const url = $(element).find('a').attr('href');

            // Check current URL is the same as the links href, if so add active class
            if (url === currentUrl) {
                $(element).addClass(ELEMENTS.MAIN_NAVIGATION_LIST_ITEM_ACTIVE);
            }
        });
    }

    /**
     * Bind mobile menu button event
     */
    const mobileMenuButton = () => {
        const button = $(`.${ELEMENTS.MOBILE_MENU_BUTTON}`);

        // Early exit if no button found
        if (button.length === 0) {
            return;
        }

        button.on('click', () => {
            button.toggleClass('active');
            showMobileMenu();
        });
    }

    /**
     * Show or hide the mobile menu
     */
    const showMobileMenu = (toggle = true, close = true) => {
        const menu = $(`.${ELEMENTS.MOBILE_MAIN_NAVIGATION_LIST}`);

        // Early exit if no menu found
        if (menu.length === 0) {
            return;
        }

        if (toggle) {
            menu.slideToggle();
        } else if (close) {
            menu.slideUp();
        }
    }

    /**
     * Close the mobile menu on window resize, if screen is wider than 1024px (desktop)
     */
    const windowResize = () => {
        $(window).on('resize', () => {
            if ($(this).width() > 1024) {
                // Reset the burger icon
                $(`.${ELEMENTS.MOBILE_MENU_BUTTON}`).removeClass('active');

                // Hide the mobile menu
                showMobileMenu(false);
            }
        });
    }

    setNavigationItemActive();
    mobileMenuButton();
    windowResize();
});